module.exports = __webpack_public_path__ + "static/product-banner-hero-5-5bbdd88e272a4d2885c5fdb7928ef389.png";